import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "8266c757-3276-4436-8eb9-008ba893cb46", content: "the pressure", options: {} },
  { id: "c65fadbc-6050-4f5e-b834-630bf47f6324", content: "the particle velocity", options: {} },
];

const groups = [
  { id: "0b3e3210-819a-4e6b-a566-cc67c97ce556", content: "the density", options: {} },
  {
    id: "cbcc8459-e00c-4d76-ac4f-da1cdf2eec95",
    content: "temporal fluctuations of the particle velocity",
    options: {},
  },
  { id: "767ce828-090a-4659-ab92-928d6283735d", content: "spatial variations of the particle velocity", options: {} },
  { id: "9f988d97-bbaf-4e06-ace8-49d2825fc8a3", content: "the atmospheric pressure", options: {} },
  { id: "05758aef-a224-4a56-a453-6d07deea4e54", content: "the temperature", options: {} },
  { id: "7d8e1d13-6d10-4ac3-b337-0473703edd9d", content: "composition of the gaz", options: {} },
];

export const task: Task = {
  id: "5b2c5131-208f-41a8-bf13-f63e309d41d7",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "0b3e3210-819a-4e6b-a566-cc67c97ce556", itemsId: ["8266c757-3276-4436-8eb9-008ba893cb46"] },
    { groupId: "cbcc8459-e00c-4d76-ac4f-da1cdf2eec95", itemsId: ["8266c757-3276-4436-8eb9-008ba893cb46"] },
    { groupId: "767ce828-090a-4659-ab92-928d6283735d", itemsId: ["c65fadbc-6050-4f5e-b834-630bf47f6324"] },
    {
      groupId: "9f988d97-bbaf-4e06-ace8-49d2825fc8a3",
      itemsId: ["8266c757-3276-4436-8eb9-008ba893cb46", "c65fadbc-6050-4f5e-b834-630bf47f6324"],
    },
    { groupId: "05758aef-a224-4a56-a453-6d07deea4e54", itemsId: [] },
    { groupId: "7d8e1d13-6d10-4ac3-b337-0473703edd9d", itemsId: ["c65fadbc-6050-4f5e-b834-630bf47f6324"] },
  ],
};
